<template>
  <div>
    <a href="#slider-after" class="skip-slider focus-visible-only button is-dark ">{{ $t('product.skip-slider') }}</a>
    <Hooper :settings="$whitelabel.hasLargeHotelSlider ? hooperSettingsLarge : hooperSettings" :progress="true"
      :autoPlay="true" :playSpeed="5000" :transition="500" ref="slider">
      <Slide v-for="(i, indx) in images" :key="indx" :index="indx">
        <img class="hooper-slide__image" src="@/assets/dummy.png" :alt="i.alt" loading="lazy" :data-src="i.imageUrl"
          width="700" height="310" fetchpriority="low" aria-live="polite" />
      </Slide>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </Hooper>
  </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'Slider',
  components: {
    Hooper,
    Slide,
    HooperPagination,
  },
  props: {
    images: Array,
  },
  data() {
    return {
      hooperSettings: {
        itemsToShow: 1,
        infiniteScroll: true,
        breakpoints: {
          754: {
            itemsToShow: 1.2,
            centerMode: true,
          },
          910: {
            itemsToShow: 1.5,
            centerMode: true,
          },
          1100: {
            itemsToShow: 1.6,
            centerMode: true,
          },
          1216: {
            itemsToShow: 2,
            centerMode: true,
          },
          1500: {
            itemsToShow: 2.5,
            centerMode: true,
          },
          1840: {
            itemsToShow: 3,
            centerMode: true,
          },
          2200: {
            itemsToShow: 3.8,
            centerMode: true,
          },
        },
      },
      hooperSettingsLarge: {
        itemsToShow: 1,
        centerMode: false,
        infiniteScroll: true,
        breakpoints: {
          754: {
            itemsToShow: 1.2,
            centerMode: true,
          },
          910: {
            itemsToShow: 1.5,
            centerMode: true,
          },
          1100: {
            itemsToShow: 1.6,
            centerMode: true,
          },
          // 1216: {
          //   itemsToShow: 2,
          //   centerMode: true,
          // },
          // 1500: {
          //   itemsToShow: 2.5,
          //   centerMode: true,
          // },
        },
      },
    }
  },
  mounted() {
    this.loadImages()
  },
  methods: {
    loadImages: () => {
      let images = document.querySelectorAll('.hooper-slide > img')

      Array.from(images).forEach(image => {
        image.setAttribute('src', image.getAttribute('data-src'))
      })
    },
    // onKeydown(e) {
    //   const hooper = this.$refs.slider
    //   console.log('keydown', e.key, hooper)

    //   if (!hooper) return

    //   if (e.key === 'ArrowRight') {
    //     hooper.slideNext()
    //     console.log('next')
    //   } else if (e.key === 'ArrowLeft') {
    //     hooper.slidePrev()
    //     console.log('prev')
    //   }
    // },
  },
}
</script>

<style lang="scss">
.hooper {
  height: auto;
}

.hooper-list {
  overflow: visible;
}

.hooper-slide {
  filter: grayscale(100%) contrast(105%);
  transition: all 200ms ease-in-out;
  transition-delay: 300ms;
}

.hooper-slide__image {
  height: 310px;
  width: auto;
  object-fit: cover;
}

.is-current {
  transform: scale(1.1);
  transform-origin: center center;

  filter: saturate(110%) contrast(110%);
  z-index: 1;
}

.hooper-pagination {
  bottom: -2.5rem;

  @media screen and (max-width: 1024px) {
    display: none;
  }
}

.hooper-indicator {
  height: 0.4rem;
  width: 1.5rem;
  border-radius: 0;

  &.is-active {
    background-color: #000;
  }
}

@media (prefers-reduced-motion: reduce) {

  .hooper-slide,
  .hooper-track {
    filter: none !important;
    transition: none !important;
  }

  .is-current {
    transform: scale(1);

    filter: none !important;
  }
}

.skip-slider {
  transform: translateX(-50%) translateY(-100%);
  left: 50%;

  &:focus-visible {
    transform: translateX(-50%) translateY(1rem);
  }
}
</style>
